import { IHttpClient } from '../../application/interfaces/http-client.interface';

export interface SocialPostDTO {
  id: string;
  platform: 'LINKEDIN' | 'INSTAGRAM' | 'FACEBOOK' | 'YOUTUBE' | 'TWITTER';
  title: string;
  content: string;
  mediaUrl?: string | null;
  postUrl: string;
  publishedAt: string;
  displayOrder: number;
}

export interface ContactInformationDTO {
  id: string;
  companyName: string;
  primaryPhone: string;
  secondaryPhone?: string | null;
  salesEmail: string;
  supportEmail?: string | null;
  addressStreet: string;
  addressCity: string;
  addressRegion: string;
  postalCode?: string | null;
  businessHours: string;
  whatsappNumber?: string | null;
  googleMapsUrl?: string | null;
}

export interface SiteSettingDTO {
  id: string;
  key: string;
  value: string;
  group: string;
  description?: string | null;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

export class HttpSettingsRepository {
  constructor(private readonly httpClient: IHttpClient) {}

  public async getLatestSocialPosts(): Promise<SocialPostDTO[]> {
    try {
      const res = await this.httpClient.get<ApiResponse<SocialPostDTO[]>>('/social-posts/latest');
      return res.data || [];
    } catch {
      return [];
    }
  }

  public async getContactInformation(): Promise<ContactInformationDTO | null> {
    try {
      const res = await this.httpClient.get<ApiResponse<ContactInformationDTO>>('/contact-information');
      return res.data || null;
    } catch {
      return null;
    }
  }

  public async getSiteSettings(): Promise<SiteSettingDTO[]> {
    try {
      const res = await this.httpClient.get<ApiResponse<SiteSettingDTO[]>>('/site-settings');
      return res.data || [];
    } catch {
      return [];
    }
  }
}
